import $ from "jquery";

/**
 * Add extra functionality to the Elementor overlay menu
 *
 * When selecting an item from the menu, automatically close the overlay
 */
$(() => {
  $(document).on("click", ".elementor-nav-menu--main .menu-item", () => {
    $("#elementor-popup-modal-2302 .dialog-close-button").trigger("click");
  });
});
